function progressUpdate() {
  if (!document.getElementById('main')) {
    return;
  }
  const scrollBottom = document.documentElement.scrollTop + window.innerHeight - window.innerHeight;
  const articleEnd = document.getElementById('main').offsetHeight + 200 - window.innerHeight;
  const postProgress = document.getElementById('post-nav-progress');

  const scrollValue = `${(scrollBottom / articleEnd) * 100}`;
  const scrollPercent = `${(scrollBottom / articleEnd) * 100}%`;
  if (postProgress) {
    if (scrollValue > 100) {
      postProgress.setAttribute('value', '100');
      document.getElementById('post-nav-progress-el').setAttribute('style', '100%');
    } else {
      postProgress.setAttribute('value', scrollValue);
      document.getElementById('post-nav-progress-el').setAttribute('style', scrollPercent);
    }
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
      document.getElementById('post-nav').setAttribute('style', 'transform: translate(-50%, 100%)');
    } else {
      document.getElementById('post-nav').setAttribute('style', 'transform: translate(-50%, 0)');
    }
  }
}

document.addEventListener('DOMContentLoaded', progressUpdate);

window.addEventListener('resize', progressUpdate);

document.addEventListener(
  'scroll',
  () => {
    progressUpdate();
  },
  { passive: true },
);
